import { render, staticRenderFns } from "./deleteCustomer.vue?vue&type=template&id=38aa2cb8&scoped=true&"
import script from "./deleteCustomer.vue?vue&type=script&lang=js&"
export * from "./deleteCustomer.vue?vue&type=script&lang=js&"
import style0 from "./deleteCustomer.vue?vue&type=style&index=0&id=38aa2cb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38aa2cb8",
  null
  
)

export default component.exports